import { render } from "./UrlForm.vue?vue&type=template&id=08a4babc&scoped=true&ts=true"
import script from "./UrlForm.vue?vue&type=script&lang=ts"
export * from "./UrlForm.vue?vue&type=script&lang=ts"

import "./UrlForm.vue?vue&type=style&index=0&id=08a4babc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a4babc"]])

export default __exports__